import React from "react";

/**
 * Thin publication ribbon at the very top of the page.
 * Mimics the masthead bar of MIT Media Lab / MIT CSAIL / academic journals.
 */
const PublicationRibbon = () => {
  return (
    <div
      data-testid="publication-ribbon"
      className="fixed top-0 left-0 right-0 z-50 bg-[#0a0a0b] text-white/70"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-2 flex items-center justify-between gap-4">
        <div className="flex items-center gap-4 sm:gap-6 text-[9px] sm:text-[10px] font-mono uppercase tracking-[0.28em] overflow-hidden whitespace-nowrap">
          <span className="text-white">Research Center</span>
          <span className="text-white/30">·</span>
          <span className="hidden md:inline">Keimyung University</span>
        </div>
        <div className="flex items-center gap-3 text-[9px] sm:text-[10px] font-mono uppercase tracking-[0.28em]">
          <span className="hidden sm:inline text-white/40">Vol. 01</span>
          <span className="hidden sm:inline text-white/30">·</span>
          <span className="text-[#00BCD4]">k/ai</span>
        </div>
      </div>
    </div>
  );
};

export default PublicationRibbon;
